import { SelectValue } from 'app/core/formly/formly.models';

export const interfaceValues: SelectValue[] = [
    { value: 1, label: 'Document' },
    { value: 2, label: 'mDocument' },
    { value: 9, label: 'fiDocument' },
    { value: 3, label: 'Table' },
    { value: 4, label: 'mTable' },
    { value: 7, label: 'Linked table' },
    { value: 13, label: 'Linked mTable' },
    { value: 8, label: 'SAP table' },
    { value: 5, label: 'File' },
    { value: 6, label: 'mFile' },
    { value: 10, label: 'Linked file' },
    { value: 11, label: 'Controlling Document' },
    { value: 12, label: 'Service' },
];
